import { createSlice } from '@reduxjs/toolkit';
import initialState from '@shared/config/translations';
// SUPPORTED_LANGUAGES carries the English-fallback merge — never import
// the raw es catalog here, a missing key would surface as undefined.
import { setSelectedLanguage, SUPPORTED_LANGUAGES } from '@shared/config/translations';

export const i18nSlice = createSlice({
  name: 'i18n',
  initialState: initialState.en,
  reducers: {
    changeLanguage: (state, action) => {
      const lang = action.payload;
      if (SUPPORTED_LANGUAGES[lang]) {
        setSelectedLanguage(lang);
        return SUPPORTED_LANGUAGES[lang];
      }
      return state;
    },
  },
});

export const { changeLanguage } = i18nSlice.actions;

export default i18nSlice.reducer;

export const getTransitionWithVariable = (text, variables) => {
  // A missing translation key must never crash the app (a global
  // consumer like IdleDialog would take every page down with it).
  if (typeof text !== 'string') return '';
  let formattedText = text;
  Object.keys(variables).forEach(key => {
    formattedText = formattedText.replace(`{{${key}}}`, variables[key]);
  });
  return formattedText;
};
